import React, { useState } from 'react';
import { MapPinIcon, PhoneIcon, MailIcon, SendIcon } from 'lucide-react';
const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [formSubmitted, setFormSubmitted] = useState(false);
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Form submission logic would go here
    setFormSubmitted(true);
    // Reset after 3 seconds
    setTimeout(() => {
      setFormSubmitted(false);
      setFormData({
        name: '',
        email: '',
        subject: '',
        message: ''
      });
    }, 3000);
  };
  return <div className="max-w-4xl mx-auto p-4 pt-20" data-id="element-1127">
      <div className="border-b border-gray-200 dark:border-gray-700 pb-4 mb-6" data-id="element-1128">
        <h1 className="text-2xl font-bold" data-id="element-1129">Contact Us</h1>
        <p className="text-gray-600 dark:text-gray-300 mt-2" data-id="element-1130">
          Get in touch with our team for any questions, feedback, or support
          needs.
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8" data-id="element-1131">
        <div data-id="element-1132">
          <h2 className="text-xl font-bold mb-4" data-id="element-1133">Contact Information</h2>
          <div className="space-y-4" data-id="element-1134">
            <div className="flex items-start" data-id="element-1135">
              <MapPinIcon className="w-5 h-5 mr-3 mt-1 text-gray-700 dark:text-gray-300" data-id="element-1136" />
              <div data-id="element-1137">
                <h3 className="font-medium" data-id="element-1138">Our Location</h3>
                <p className="text-gray-600 dark:text-gray-400" data-id="element-1139">
                  Westlands Business Park
                  <br data-id="element-1140" />
                  Nairobi, Kenya
                </p>
              </div>
            </div>
            <div className="flex items-start" data-id="element-1141">
              <PhoneIcon className="w-5 h-5 mr-3 mt-1 text-gray-700 dark:text-gray-300" data-id="element-1142" />
              <div data-id="element-1143">
                <h3 className="font-medium" data-id="element-1144">Phone</h3>
                <p className="text-gray-600 dark:text-gray-400" data-id="element-1145">
                  +254 100 254 254
                  <br data-id="element-1146" />
                  Mon-Fri, 8:00 AM - 5:00 PM
                </p>
              </div>
            </div>
            <div className="flex items-start" data-id="element-1147">
              <MailIcon className="w-5 h-5 mr-3 mt-1 text-gray-700 dark:text-gray-300" data-id="element-1148" />
              <div data-id="element-1149">
                <h3 className="font-medium" data-id="element-1150">Email</h3>
                <p className="text-gray-600 dark:text-gray-400" data-id="element-1151">
                  info@jointoday.co.ke
                  <br data-id="element-1152" />
                  support@jointoday.co.ke
                </p>
              </div>
            </div>
          </div>
          <div className="mt-8" data-id="element-1153">
            <h2 className="text-xl font-bold mb-4" data-id="element-1154">Connect With Us</h2>
            <div className="flex space-x-4" data-id="element-1155">
              <a href="#" className="w-10 h-10 border border-gray-300 dark:border-gray-600 rounded-full flex items-center justify-center" data-id="element-1156">
                <span className="text-xl" data-id="element-1157">📱</span>
              </a>
              <a href="#" className="w-10 h-10 border border-gray-300 dark:border-gray-600 rounded-full flex items-center justify-center" data-id="element-1158">
                <span className="text-xl" data-id="element-1159">📘</span>
              </a>
              <a href="#" className="w-10 h-10 border border-gray-300 dark:border-gray-600 rounded-full flex items-center justify-center" data-id="element-1160">
                <span className="text-xl" data-id="element-1161">🐦</span>
              </a>
              <a href="#" className="w-10 h-10 border border-gray-300 dark:border-gray-600 rounded-full flex items-center justify-center" data-id="element-1162">
                <span className="text-xl" data-id="element-1163">📸</span>
              </a>
            </div>
          </div>
        </div>
        <div data-id="element-1164">
          <h2 className="text-xl font-bold mb-4" data-id="element-1165">Send Us Feedback</h2>
          {formSubmitted ? <div className="border border-gray-300 dark:border-gray-600 rounded-lg p-4 bg-gray-50 dark:bg-gray-700 text-center" data-id="element-1166">
              <div className="w-16 h-16 bg-gray-200 dark:bg-gray-600 rounded-full mx-auto flex items-center justify-center mb-3" data-id="element-1167">
                <span className="text-2xl" data-id="element-1168">✓</span>
              </div>
              <h3 className="font-medium mb-2" data-id="element-1169">Thank You!</h3>
              <p className="text-gray-600 dark:text-gray-400" data-id="element-1170">
                Your message has been received. We'll get back to you shortly.
              </p>
            </div> : <form onSubmit={handleSubmit} className="space-y-4" data-id="element-1171">
              <div data-id="element-1172">
                <label htmlFor="name" className="block text-sm font-medium mb-1" data-id="element-1173">
                  Your Name
                </label>
                <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} className="w-full p-2 border border-gray-300 dark:border-gray-600 rounded-md dark:bg-gray-700" required data-id="element-1174" />
              </div>
              <div data-id="element-1175">
                <label htmlFor="email" className="block text-sm font-medium mb-1" data-id="element-1176">
                  Email Address
                </label>
                <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} className="w-full p-2 border border-gray-300 dark:border-gray-600 rounded-md dark:bg-gray-700" required data-id="element-1177" />
              </div>
              <div data-id="element-1178">
                <label htmlFor="subject" className="block text-sm font-medium mb-1" data-id="element-1179">
                  Subject
                </label>
                <input type="text" id="subject" name="subject" value={formData.subject} onChange={handleChange} className="w-full p-2 border border-gray-300 dark:border-gray-600 rounded-md dark:bg-gray-700" required data-id="element-1180" />
              </div>
              <div data-id="element-1181">
                <label htmlFor="message" className="block text-sm font-medium mb-1" data-id="element-1182">
                  Message
                </label>
                <textarea id="message" name="message" value={formData.message} onChange={handleChange} rows={5} className="w-full p-2 border border-gray-300 dark:border-gray-600 rounded-md dark:bg-gray-700" required data-id="element-1183"></textarea>
              </div>
              <button type="submit" className="flex items-center bg-gray-800 dark:bg-gray-200 text-white dark:text-gray-800 rounded-md px-4 py-2" data-id="element-1184">
                <SendIcon className="w-4 h-4 mr-2" data-id="element-1185" />
                Send Message
              </button>
            </form>}
        </div>
      </div>
      <div className="border border-gray-300 dark:border-gray-600 rounded-lg overflow-hidden h-64 mb-8" data-id="element-1186">
        <div className="h-full w-full bg-gray-200 dark:bg-gray-700 flex items-center justify-center" data-id="element-1187">
          <span className="text-gray-500 dark:text-gray-400" data-id="element-1188">Map Location</span>
        </div>
      </div>
      <div className="border-t border-gray-200 dark:border-gray-700 pt-6 mb-6" data-id="element-1189">
        <h2 className="text-xl font-bold mb-4" data-id="element-1190">Frequently Asked Questions</h2>
        <div className="space-y-4" data-id="element-1191">
          <div className="border border-gray-300 dark:border-gray-600 rounded-lg p-4" data-id="element-1192">
            <h3 className="font-medium mb-2" data-id="element-1193">How do I create an account?</h3>
            <p className="text-gray-600 dark:text-gray-400" data-id="element-1194">
              You can create an account by clicking on the "Sign Up" button in
              the top navigation bar and following the registration process.
            </p>
          </div>
          <div className="border border-gray-300 dark:border-gray-600 rounded-lg p-4" data-id="element-1195">
            <h3 className="font-medium mb-2" data-id="element-1196">
              How can I list my event on JoinToday?
            </h3>
            <p className="text-gray-600 dark:text-gray-400" data-id="element-1197">
              To list an event, you need to register as an Event Organizer. Once
              registered, you can create and manage events through your
              dashboard.
            </p>
          </div>
          <div className="border border-gray-300 dark:border-gray-600 rounded-lg p-4" data-id="element-1198">
            <h3 className="font-medium mb-2" data-id="element-1199">
              What payment methods are accepted?
            </h3>
            <p className="text-gray-600 dark:text-gray-400" data-id="element-1200">
              We accept M-Pesa, credit/debit cards, and other popular payment
              methods for ticket purchases and transactions.
            </p>
          </div>
        </div>
      </div>
    </div>;
};
export default Contact;